"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANGUAGE_TO_LOCALE_MAP = exports.WORLD_REGIONS_CODES = exports.DEFAULT_LOCALE_CODES = exports.DEFAULT_LOCALE = exports.LocaleCode = exports.Locale = void 0;
/** @deprecated */
var Locale;
(function (Locale) {
    Locale["EN"] = "en";
    Locale["PT"] = "pt";
    Locale["ZH"] = "zh";
    Locale["SV"] = "sv";
    Locale["RU"] = "ru";
    Locale["RU_RF"] = "ru_RF";
    Locale["DE"] = "de";
    Locale["FI"] = "fi";
    Locale["UK"] = "uk";
    Locale["PL"] = "pl";
    Locale["JA"] = "ja";
    Locale["ES"] = "es";
    Locale["RO"] = "ro";
    Locale["EN_CA"] = "en_CA";
    Locale["FR_CA"] = "fr_CA";
    Locale["HU"] = "hu";
})(Locale = exports.Locale || (exports.Locale = {}));
/** @deprecated */
var LocaleCode;
(function (LocaleCode) {
    LocaleCode["EN_US"] = "en_US";
    LocaleCode["PT_PT"] = "pt_PT";
    LocaleCode["ZH_CN"] = "zh_CN";
    LocaleCode["SV_SE"] = "sv_SE";
    LocaleCode["RU_RU"] = "ru_RU";
    LocaleCode["RU_RF"] = "ru_RF";
    LocaleCode["DE_DE"] = "de_DE";
    LocaleCode["FI_FI"] = "fi_FI";
    LocaleCode["UK_UA"] = "uk_UA";
    LocaleCode["PL_PL"] = "pl_PL";
    LocaleCode["JA_JP"] = "ja_JP";
    LocaleCode["ES_ES"] = "es_ES";
    LocaleCode["RO_RO"] = "ro_RO";
    LocaleCode["EN_CA"] = "en_CA";
    LocaleCode["FR_CA"] = "fr_CA";
    LocaleCode["HU_HU"] = "hu_HU";
})(LocaleCode = exports.LocaleCode || (exports.LocaleCode = {}));
/** @deprecated */
exports.DEFAULT_LOCALE = LocaleCode.EN_US;
/** @deprecated */
exports.DEFAULT_LOCALE_CODES = Object.values(LocaleCode);
exports.WORLD_REGIONS_CODES = {
    'WW-OCEANIA': 'Oceania',
    'WW-AMERICAS': 'Americas',
    'WW-CIS': 'CIS',
    'WW-SEA': 'SEA',
    EU: 'European Union',
    WW: 'World',
    'WW-NAM': 'North America',
    'WW-SAM': 'South America',
    'WW-EUR': 'Europe',
    'WW-AFR': 'Africa',
    'WW-ASI': 'Asia',
    'WW-AUS': 'Australia',
    'GB-ENG': 'England',
    'GB-SCT': 'Scotland',
    'GB-WLS': 'Wales',
    'GB-NIR': 'Northern Ireland',
};
/** @deprecated */
var LocaleToLocaleCode = /** @class */ (function () {
    function LocaleToLocaleCode() {
        this[_a] = LocaleCode.EN_US;
        this[_b] = LocaleCode.PT_PT;
        this[_c] = LocaleCode.ZH_CN;
        this[_d] = LocaleCode.SV_SE;
        this[_e] = LocaleCode.RU_RU;
        this[_f] = LocaleCode.RU_RF;
        this[_g] = LocaleCode.DE_DE;
        this[_h] = LocaleCode.FI_FI;
        this[_j] = LocaleCode.UK_UA;
        this[_k] = LocaleCode.PL_PL;
        this[_l] = LocaleCode.JA_JP;
        this[_m] = LocaleCode.ES_ES;
        this[_o] = LocaleCode.RO_RO;
        this[_p] = LocaleCode.EN_CA;
        this[_q] = LocaleCode.FR_CA;
        this[_r] = LocaleCode.HU_HU;
    }
    return LocaleToLocaleCode;
}());
_a = Locale.EN, _b = Locale.PT, _c = Locale.ZH, _d = Locale.SV, _e = Locale.RU, _f = Locale.RU_RF, _g = Locale.DE, _h = Locale.FI, _j = Locale.UK, _k = Locale.PL, _l = Locale.JA, _m = Locale.ES, _o = Locale.RO, _p = Locale.EN_CA, _q = Locale.FR_CA, _r = Locale.HU;
/** @deprecated */
exports.LANGUAGE_TO_LOCALE_MAP = new LocaleToLocaleCode();
//# sourceMappingURL=locales.js.map